import React from 'react';
import propTypes from 'prop-types';
import {
  ImageWrapper,
  LoaderWrapper,
  ProfileIcon,
  IconWrapper,
  Image,
} from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/personalInfo';
import {
  Loader,
  Camera,
} from '../../../../../editJournal/toolset/assets/icons';

const RenderImage = (props) => {
  const { blobPresent, blobURL, isUploading } = props;
  return (
    <>
      {
        {
          true: (
            <ImageWrapper isUploading={isUploading}>
              <Image src={blobURL} alt="" isUploading={isUploading} />
              <LoaderWrapper>{isUploading && <Loader />}</LoaderWrapper>
            </ImageWrapper>
          ),
          false: <Loader />,
          defaultPicture: (
            <ProfileIcon>
              <IconWrapper>
                <Camera />
              </IconWrapper>
            </ProfileIcon>
          ),
          empty: <></>,
        }[blobPresent]
      }
    </>
  );
};

RenderImage.propTypes = {
  blobPresent: propTypes.bool.isRequired,
  blobURL: propTypes.bool.isRequired,
  isUploading: propTypes.bool.isRequired,
};

export default RenderImage;
